import { Routes } from '@angular/router';
import { NotfoundComponent } from './pages/notfound/notfound.component';
import { AboutComponent } from './pages/about/about.component';
import { ContactComponent } from './pages/contact/contact.component';
import { App } from './app';
import { HomeComponent } from './pages/home/home.component';
import { BachloriaregisterComponent } from './pages/bachloriaregister/bachloriaregister.component';

export const routes: Routes = [
{path:'home',component:HomeComponent},
{path:'about',component:AboutComponent},
{path:'contact',component:ContactComponent},
{path:'bachloria',component:BachloriaregisterComponent},
{path:'',component:HomeComponent},
{path:'**',component:NotfoundComponent}

];
